pctCookiesConfig.translations.en = {
    consentNotice: {
        description: 'Cookies are important for you, they influence on your browsing experience, they help us to protect your privacy\n' +
            'and allow us to proceed with your requests that you demand through the website. We use our own and third-\n' +
            'party cookies to analyze our services and provide you with advertising related to your preferences on the basis\n' +
            'of a profile made with your browsing habits (for example, visited pages). If you consent to its installation, click on\n' +
            '"Accept Cookies", or you can also set your preferences by pressing "Cookie settings". More information in our\n' +
            '<a href="/en/cookies-policy">Cookie policy</a>.',
        learnMore: 'Cookie settings'
    },
    ok: 'Accept cookies'
};